import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/file.svg'


const _withScopeId = n => (_pushScopeId("data-v-48e66520"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-files-header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "d-files-header__title" }, "My Files", -1))
const _hoisted_3 = { class: "d-files-header__buttons" }
const _hoisted_4 = { class: "buttons-back-link" }
const _hoisted_5 = { class: "buttons-done-button" }
const _hoisted_6 = {
  key: 0,
  class: "d-layout-switcher"
}
const _hoisted_7 = { class: "file-wrapper" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "file" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "casedrive file"
}, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "checker checked"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-check" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 1,
  class: "checker unchecked"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-close" }, null, -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "file-name" }
const _hoisted_19 = {
  class: "file-box spacer",
  ref: "spacer"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_skeleton_media = _resolveComponent("app-skeleton-media")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"]))
              }, _toDisplayString(_ctx.$localize('drive.view.add.photos.from.drive.backtext')), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                href: "javascript:void(0);",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('addSelectedFiles')), ["prevent"])),
                class: "link"
              }, _toDisplayString(_ctx.$localize('drive.done.button')), 1)
            ])
          ]),
          (_ctx.showLayoutSwitcher)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", {
                  class: _normalizeClass(["d-layout-switcher__btn icon", !_ctx.driveStore.isGridFolderView ? 'active icon-list-view-2-active' : 'icon-list-view-2']),
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.driveStore.isGridFolderView = false))
                }, null, 2),
                _createElementVNode("span", {
                  class: _normalizeClass(["d-layout-switcher__btn icon", _ctx.driveStore.isGridFolderView ? 'active icon-tiles-2-active' : 'icon-tiles-2']),
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.driveStore.isGridFolderView = true))
                }, null, 2)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["scroll", {selector: _ctx.selector, 'scroll--hide-footer': _ctx.hideFooter}]),
      onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
      ref: "scroller"
    }, [
      _createElementVNode("div", _hoisted_7, [
        (!_ctx.dataLoading)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.files, (file) => {
              return (_openBlock(), _createElementBlock("div", {
                key: file.id,
                style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin),
                onClick: ($event: any) => (_ctx.selectFile(file)),
                class: "file-box"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  (_ctx.selector)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (file.selected)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, _hoisted_13))
                          : (_openBlock(), _createElementBlock("div", _hoisted_14))
                      ], 64))
                    : (!_ctx.isNetwork)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          onClick: ($event: any) => (_ctx.deleteFile(file.id)),
                          class: "closer"
                        }, _hoisted_17, 8, _hoisted_15))
                      : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_18, _toDisplayString(file.name), 1)
              ], 12, _hoisted_8))
            }), 128))
          : _createCommentVNode("", true),
        (_ctx.isPageLoading || _ctx.dataLoading)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(15, (n) => {
              return _createElementVNode("div", {
                key: n,
                class: "file-box"
              }, [
                _createVNode(_component_app_skeleton_media, {
                  style: _normalizeStyle('height: ' + _ctx.itemHeight + '; margin-bottom: ' + _ctx.itemMargin)
                }, null, 8, ["style"])
              ])
            }), 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, null, 512)
      ])
    ], 34)
  ]))
}